import { Line } from 'react-chartjs-2';
import Colors from 'assets/Colors';
import Loading from 'components/common/loading';
import { useTranslation } from 'react-i18next';
import s from './styles';

function LineChart({ list = [], loading, firstGraph }) {
  const { t } = useTranslation();
  const values1 = list.map((element) => element.number);
  const values2 = list.map((element) => element.number2);

  const options = ({ maxLine1, maxLine2, minLine1, minLine2 }) => ({
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const datasetIndex = tooltipItem.datasetIndex;
            return `${tooltipItem.raw} ${datasetIndex === 0 ? "€" : ""}`;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        labels: {
          title: null,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    scales: {
      y: {
        display: true,
        title: {
          display: true,
          text: t('components.ReportSales.LineChart.money'),
        },
        position: 'left',
        type: 'linear',
        suggestedMin: minLine1 < 0 ? minLine1 : 0,
        suggestedMax: maxLine1 || 10,
      },
      y2: {
        display: true,
        title: {
          display: true,
          text: t('components.ReportSales.LineChart.sells'),
        },
        position: 'right',
        type: 'linear',
        suggestedMin: minLine2 < 0 ? minLine2 : 0,
        suggestedMax: maxLine2 || 10,
      },
    },
  });
  

  const data = {
    labels: list.map((element) => element.label),
    datasets: [
      {
        data: values1,
        fill: false,
        borderColor: Colors.text_primary,
        backgroundColor: Colors.text_primary,
        tension: 0.1,
        yAxisID: 'y',
      },
      {
        data: values2,
        fill: false,
        borderColor: Colors.background_dividers,
        backgroundColor: Colors.background_dividers,
        tension: 0.1,
        yAxisID: 'y2',
      },
    ],
  };

  return (
    <s.Container>
      {loading ? (
        <Loading height="100%" size="middle" />
      ) : (
        <div ref={firstGraph}>
          <s.Title>
            {t('components.ReportSales.LineChart.sellsEarnings')}{' '}
            <s.LabelWrapper>
              <s.LabelColorCircle color={Colors.text_primary} />
              <s.LabelText>
                {t('components.ReportSales.LineChart.earnings')}
              </s.LabelText>
              <s.LabelColorCircle color={Colors.background_dividers} />
              <s.LabelText>
                {t('components.ReportSales.LineChart.sells')}
              </s.LabelText>
            </s.LabelWrapper>
          </s.Title>
          <s.ChartWrapper>
            <Line
              data={data}
              options={options({
                maxLine1: Math.max.apply(Math, values1),
                maxLine2: Math.max.apply(Math, values2),
                minLine1: Math.min.apply(Math, values1),
                minLine2: Math.min.apply(Math, values2),
              })}
            />
          </s.ChartWrapper>
        </div>
      )}
    </s.Container>
  );
}

export default LineChart;
